import React from 'react'
import ActionDropdownToggler from './ActionsDropdownToggler'
import { Dropdown, DropdownItem } from '@vega/components'

export default function Actions({ recordId, actions }) {
  return (
    <Dropdown
      dropdownMenuProps={{
        style: {
          top: 10,
          right: 20,
        },
      }}
      Toggler={({ toggle }) => <ActionDropdownToggler onClick={toggle} />}
    >
      {actions.map(({ name, onClick }) => (
        <DropdownItem key={name} text={name} onClick={onClick(recordId)} />
      ))}
    </Dropdown>
  )
}
